module.exports = __webpack_public_path__ + "img/dnt.975afd3b.svg";